var map = {
	"./amex.png": 9591,
	"./chip.png": 8952,
	"./dinersclub.png": 7295,
	"./discover.png": 8765,
	"./jcb.png": 6682,
	"./mastercard.png": 6208,
	"./troy.png": 3941,
	"./unionpay.png": 7610,
	"./visa.png": 2016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6034;